import { Spinner, Typography } from '@scale/scaleui';
import { Alert } from 'react-scale/components/scalers/tasks/ThreadedInteraction/TempComponents';
import { ProcessCritiqueOutput } from 'react-scale/components/scalers/tasks/ThreadedInteraction/hooks/useProcessCritique';

interface Props {
  processCritiqueOutput: ProcessCritiqueOutput;
  hasGtfa: boolean;
}

function ProcessCritiqueAlert(props: Props) {
  const { processCritiqueOutput, hasGtfa } = props;

  const processCritiqueHeaders = () => {
    if (processCritiqueOutput.error) {
      return 'Process Critique ran into an error, you may try running it again.';
    } else if (processCritiqueOutput.loading) {
      return 'Running Process Critique...';
    } else if (!processCritiqueOutput.hasRun) {
      return 'Run Process Critique to detect issues';
    } else if (processCritiqueOutput.step === -1) {
      return 'All steps may be correct. No issues detected in the process.';
    } else {
      return `There may be an issue with one of the steps (${processCritiqueOutput.step}). Please review the step closely.`;
    }
  };

  const processCritiqueBody = () => {
    if (processCritiqueOutput.error) {
      return 'Something went wrong when running process critique. Please try again.';
    } else if (!processCritiqueOutput.hasRun) {
      return `${
        hasGtfa
          ? 'Enter the ground truth answer into the box above and click "Run Process Critique" to automatically detect issues. '
          : ''
      }Please note that this system is provided as a guide and not guarenteed to be accurate. You are ultimately responsible to ensure that the ground truth answer is accurate and its critique's assessment is accurate.`;
    } else if (processCritiqueOutput.loading) {
      return 'Running process critique...';
    } else if (processCritiqueOutput.step === -1) {
      return 'All steps may be correct. No issues detected in the process.';
    } else {
      return (
        <div>
          <div className="mb-1">
            <b>Reason:</b> {processCritiqueOutput.reason}
          </div>
          <div>
            <b>Corrected Step:</b> {processCritiqueOutput.correctedStep}
          </div>
        </div>
      );
    }
  };

  const processCritiqueVariant = () => {
    if (processCritiqueOutput.error) {
      return 'danger';
    } else if (!processCritiqueOutput.hasRun || processCritiqueOutput.loading) {
      return 'info';
    } else if (processCritiqueOutput.step === -1) {
      return 'info';
    } else {
      return 'danger';
    }
  };

  return (
    <div>
      <Alert
        className={`px-5 ${processCritiqueOutput.loading && 'opacity-50'}`}
        variant={processCritiqueVariant()}
      >
        <Typography.Paragraph2>
          <div className="p-5">
            <Typography.Subtitle3>
              <b>
                <div className="flex items-center">
                  {processCritiqueOutput.loading && <Spinner size="sm" className="mr-3" />}
                  {processCritiqueHeaders()}
                </div>
              </b>
            </Typography.Subtitle3>
            <hr className="my-3" />

            <div className="mt-2 font-sm">
              {processCritiqueBody()}

              <div className="mt-3">
                <i>
                  This assessment is based on an automatic analysis of the response.{' '}
                  <b>
                    <u>You are ultimately responsible</u>
                  </b>{' '}
                  for ensuring the process supervision assessment system is accurate and its
                  assessment is accurate.
                </i>
              </div>
            </div>
          </div>
        </Typography.Paragraph2>
      </Alert>
    </div>
  );
}

export default ProcessCritiqueAlert;
